import React from 'react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '200px',
    flexDirection: 'column',
    gap: 16,
    padding: 24,
    background: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: 12,
    margin: '20px 0'
  }}>
    <div style={{ color: '#dc2626', fontSize: 18, fontWeight: 600 }}>
      ⚠️ Error Loading Data
    </div>
    <div style={{ color: '#991b1b', fontSize: 14, textAlign: 'center' }}>
      {message}
    </div>
    {onRetry && (
      <button 
        onClick={onRetry}
        style={{
          background: '#dc2626',
          color: 'white',
          border: 'none',
          borderRadius: 8,
          padding: '8px 16px',
          fontSize: 14,
          fontWeight: 500,
          cursor: 'pointer'
        }}
      >
        Try Again
      </button>
    )}
  </div>
);

export default ErrorMessage; 